import { createStructuredSelector } from 'reselect';
import { bool, func, shape } from 'prop-types';
import { selectIsLoading, select_indusindMinKycCities, select_indusindMinKycUser, select_indusindMinKycUserInfo } from './selectors';
import { indusindMinKycCities, indusindMinKycUpdate, indusindMinKycUserInfo } from './actions';
import { getUpdatedUserProfile } from '../HeaderContainer/actions';
import { SET_INDUSIND_MIN_KYC_USER_INFO_SUCCESS } from './constants';

/**
* @class IndusindMinKyc
*/

const IndusindMinKycProps = {
  isLoadingStatus: bool.isRequired,
  history: shape({}).isRequired,
  IndusindMinKycUserInfo: shape({}).isRequired,
  IndusindMinKycUserUpdateSuccess: shape({}).isRequired,
  onInitIndusindMinKycCities: func.isRequired,
  onInitIndusindMinKycUserInfo: func.isRequired,
  onInitIndusindMinKycUpdate: func.isRequired,
  onInitUpdatedUserProfile: func.isRequired,
  onResetIndusindMinKycUserInfo: func.isRequired,
};

const IndusindMinKycDispatchToProps = (dispatch) => ({
  onInitIndusindMinKycCities: (payload) => dispatch(indusindMinKycCities(payload)),
  onInitIndusindMinKycUserInfo: (payload) => dispatch(indusindMinKycUserInfo(payload)),
  onInitIndusindMinKycUpdate: (payload) => dispatch(indusindMinKycUpdate(payload)),
  onInitUpdatedUserProfile: () => dispatch(getUpdatedUserProfile()),
  onResetIndusindMinKycUserInfo: (payload) => dispatch({ type: SET_INDUSIND_MIN_KYC_USER_INFO_SUCCESS, payload }),
});

const IndusindMinKycmapStateToProps = createStructuredSelector({
  isLoadingStatus: selectIsLoading(),
  IndusindMinKycUserInfo: select_indusindMinKycUserInfo(),
  IndusindMinKycUserUpdateSuccess: select_indusindMinKycUser(),
});

/**
* @class PersonalAddressForm
*/

const PersonalAddressFormProps = {
  form: shape({}).isRequired,
  IndusindMinKycUserInfo: shape({}).isRequired,
  formValues: shape({}).isRequired,
  handleNextStep: func.isRequired,
  onInitIndusindMinKycCities: func.isRequired,
};

const PersonalAddressFormmapStateToProps = createStructuredSelector({
  IndusindMinKycUserInfo: select_indusindMinKycUserInfo(),
});

/**
* @class ResidentialAddressForm
*/

const ResidentialAddressFormProps = {
  checkboxValue: bool.isRequired,
  form: shape({}).isRequired,
  IndusindMinKycCities: shape({}).isRequired,
  IndusindMinKycUserInfo: shape({}).isRequired,
  formValues: shape({}).isRequired,
  residentialAddressValues: shape({}).isRequired,
  preferredAddressValues: shape({}).isRequired,
  handleNextStep: func.isRequired,
  handlePrevStep: func.isRequired,
  onInitIndusindMinKycCities: func.isRequired,
};

const ResidentialAddressFormmapStateToProps = createStructuredSelector({
  IndusindMinKycCities: select_indusindMinKycCities(),
  IndusindMinKycUserInfo: select_indusindMinKycUserInfo(),
});

/**
* @class WorkAddressForm
*/

const WorkAddressFormProps = {
  checkboxValue: bool.isRequired,
  isLoadingStatus: bool.isRequired,
  form: shape({}).isRequired,
  IndusindMinKycCities: shape({}).isRequired,
  IndusindMinKycUserInfo: shape({}).isRequired,
  formValues: shape({}).isRequired,
  workAddressValues: shape({}).isRequired,
  handlePrevStep: func.isRequired,
  handleFormSubmit: func.isRequired,
  onInitIndusindMinKycCities: func.isRequired,
};


const WorkAddressFormmapStateToProps = createStructuredSelector({
  IndusindMinKycCities: select_indusindMinKycCities(),
  IndusindMinKycUserInfo: select_indusindMinKycUserInfo(),
});

export {
  IndusindMinKycProps,
  IndusindMinKycmapStateToProps,
  IndusindMinKycDispatchToProps,
  PersonalAddressFormProps,
  ResidentialAddressFormProps,
  WorkAddressFormProps,
  PersonalAddressFormmapStateToProps,
  ResidentialAddressFormmapStateToProps,
  WorkAddressFormmapStateToProps,
};



// WEBPACK FOOTER //
// client/containers/IndusindMinKyc/IndusindMinKycDataHandler.js